import {
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonMenu,
  IonMenuToggle,
  IonTitle,
  IonToolbar
} from '@ionic/react';
import React, { useContext, useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { AppPage } from '../declarations';
import PartyList from '../pages/Ledger/PartyList';
import { ConfigContext } from '../contexts/ConfigContext';
// import { home } from 'ionicons/icons';

interface MenuProps extends RouteComponentProps {
  appPages: AppPage[];
}

const Menu: React.FunctionComponent<MenuProps> = ({ appPages }) => {

  const { getCompany } = useContext(ConfigContext)
  const [Company, setCompany] = useState({
    name: '',
  })

  useEffect(() => {
    getCompany().then((res: {
      name: string;
    }) => {
      setCompany(res)
    })

    return () => {}
  }, [getCompany])

  let cname = ((Company) && Company?.name) || "Billing Inc"

  return (
    <>
      <PartyList />
      <IonMenu menuId='mainmenu' contentId="main" type="overlay" >
        <IonHeader >
          <IonToolbar color='danger'>
            <IonTitle >{cname}</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent >
          <IonList >
            {appPages.map((appPage, index) => {
              return (
                <IonMenuToggle key={index} autoHide={false}>
                  <IonItem routerLink={appPage.url} routerDirection="none">
                    <IonIcon slot="start" icon={appPage.icon} />
                    <IonLabel>{appPage.title}</IonLabel>
                  </IonItem>
                </IonMenuToggle>
              );
            })}
          </IonList>
        </IonContent>
      </IonMenu>
    </>
  )
};

export default withRouter(Menu);
